/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { SelectControl } from '@wordpress/components';
import googleFonts from './fonts';
import Select from 'react-select';

function FontFamilyControl(props) {
	const fonts = [
		{
			value: '',
			label: __('Default'),
			weight: [
				'100',
				'200',
				'300',
				'400',
				'500',
				'600',
				'700',
				'800',
				'900',
			],
			google: false,
		},
		{
			value: 'Arial',
			label: 'Arial',
			weight: [
				'100',
				'200',
				'300',
				'400',
				'500',
				'600',
				'700',
				'800',
				'900',
			],
			google: false,
		},
		{
			value: 'Helvetica',
			label: 'Helvetica',
			weight: [
				'100',
				'200',
				'300',
				'400',
				'500',
				'600',
				'700',
				'800',
				'900',
			],
			google: false,
		},
		{
			value: 'Times New Roman',
			label: 'Times New Roman',
			weight: [
				'100',
				'200',
				'300',
				'400',
				'500',
				'600',
				'700',
				'800',
				'900',
			],
			google: false,
		},
		{
			value: 'Georgia',
			label: 'Georgia',
			weight: [
				'100',
				'200',
				'300',
				'400',
				'500',
				'600',
				'700',
				'800',
				'900',
			],
			google: false,
		},
	];

	let fontWeight = '';
	let fontSubset = '';

	//Push Google Fonts into stytem fonts object
	Object.keys(googleFonts).forEach((k) => {
		fonts.push({ value: k, label: k, weight: googleFonts[k].weight });

		if (k === props.fontFamily.value) {
			fontWeight = googleFonts[k].weight;
			fontSubset = googleFonts[k].subset;
		}
	});

	// check if the font is a system font and then apply the font weight accordingly.
	if (fontWeight === '') {
		fontWeight = fonts[0].weight;
	}

	const fontWeightObj = [];

// Ensure fontWeight is an array
if (typeof fontWeight === 'string') {
    fontWeight = [fontWeight];
}
fontWeight.forEach(function (item) {
    fontWeightObj.push({ value: item, label: item });
});
	const fontSubsetObj = [];

	if (typeof fontSubset === 'object') {
		fontSubset.forEach(function (item) {
			fontSubsetObj.push({ value: item, label: item });
		});
	}

	const onFontfamilyChange = (value) => {
		const { loadGoogleFonts, fontFamily, fontWeightt, fontSubsett } = props;
		props.setAttributes({ [fontFamily.label]: value.label });
		onLoadGoogleFonts(loadGoogleFonts, value.label);
		onFontChange(fontWeightt, fontSubsett, value.label);
	};

	const onFontChange = (fontWeightt, fontSubsett, fontFamily) => {
		let newValue;

		if (typeof googleFonts[fontFamily] === 'object') {
			const gfontsObj = googleFonts[fontFamily].weight;
			const gfontSubsetObj = googleFonts[fontFamily].subset;

			if (typeof gfontsObj === 'object') {
				gfontsObj.forEach(function (item) {
					newValue = item;
					props.setAttributes({
						[props.fontWeight.label]: newValue,
					});
				});

				gfontSubsetObj.forEach(function (item) {
					newValue = item;
					props.setAttributes({
						[props.fontSubset.label]: newValue,
					});
				});
			}
		}
	};

	const onLoadGoogleFonts = (loadGoogleFonts, fontFamily) => {
		let value;

		if (fontFamily !== '' && typeof googleFonts[fontFamily] !== 'object') {
			value = false;
		} else {
			value = true;
		}

		props.setAttributes({ [loadGoogleFonts.label]: value });
	};

	return (
		<div className="wpsp-typography-font-family-options">
			<label
				htmlFor="font-family"
				className="wpsp-typography-font-family-label"
			>
				{__('Font Family')}
			</label>
			<Select
				options={fonts}
				value={{
					value: props.fontFamily.value,
					label: props.fontFamily.value,
					weight: fontWeightObj,
				}}
				isMulti={false}
				maxMenuHeight={300}
				onChange={onFontfamilyChange}
				className="react-select-container"
				classNamePrefix="react-select"
			/>
			<SelectControl
				label={__('Font Weight')}
				value={props.fontWeight.value}
				onChange={(value) =>
					props.setAttributes({ [props.fontWeight.label]: value })
				}
				options={fontWeightObj}
			/>
			<SelectControl
				label={__('Font Subset')}
				value={props.fontSubset.value}
				onChange={(value) =>
					props.setAttributes({ [props.fontSubset.label]: value })
				}
				options={fontSubsetObj}
			/>
		</div>
	);
}

export default FontFamilyControl;
